// This file is auto-generated by @hey-api/openapi-ts
import { formDataBodySerializer } from './client';
import { client } from './client.gen';
export const systemTranslationControllerClear = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/system/translation/{type}/{id}/{locale}', ...options }); };
export const systemTranslationControllerSave = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/system/translation/{type}/{id}/{locale}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemTemplateControllerGetAllNew = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/template', ...options }); };
export const systemTemplateControllerCreateNewTemplate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/system/template',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemTemplateControllerUpdateNewTemplate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/system/template',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemPartnershipControllerDelete = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/system/partnership/{id}', ...options }); };
export const systemPartnershipControllerGetById = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/partnership/{id}', ...options }); };
export const systemPartnershipControllerUpdate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/system/partnership/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemPartnershipControllerDeactivate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/system/partnership/{id}/deactivate', ...options }); };
export const systemPartnershipControllerActivate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/system/partnership/{id}/activate', ...options }); };
export const systemPartnershipControllerGetMarketplaceOpen = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/partnership/marketplace-open', ...options }); };
export const systemPartnershipControllerSetMarketplaceOpen = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/system/partnership/marketplace-open', ...options }); };
export const systemFoodDictionaryControllerDeleteFood = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/system/food-dictionary/{id}', ...options }); };
export const systemFoodDictionaryControllerGetFoodById = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/food-dictionary/{id}', ...options }); };
export const systemFoodDictionaryControllerUpdateFood = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/system/food-dictionary/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemFoodDictionaryControllerRemoveServing = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/system/food-dictionary/{id}/servings/{servingId}', ...options }); };
export const systemFoodDictionaryControllerUpdateServing = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/system/food-dictionary/{id}/servings/{servingId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemFoodDictionaryControllerChangeScope = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/system/food-dictionary/{id}/scope',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemFoodDictionaryControllerUpdateFoodGroup = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/system/food-dictionary/{id}/food-group',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemFoodDictionaryControllerUpdateCertified = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/system/food-dictionary/{id}/certified',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemCouponControllerDeleteCoupon = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/system/coupon/{id}', ...options }); };
export const systemCouponControllerGetCouponById = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/coupon/{id}', ...options }); };
export const systemCouponControllerUpdateCoupon = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/system/coupon/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemCouponControllerDeactivateCoupon = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/system/coupon/{id}/deactivate', ...options }); };
export const systemCouponControllerActivateCoupon = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/system/coupon/{id}/activate', ...options }); };
export const systemCompanyGroupAdminControllerDelete = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/system/companyGroupAdmin/{id}', ...options }); };
export const systemCompanyGroupAdminControllerGet = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/companyGroupAdmin/{id}', ...options }); };
export const systemCompanyGroupAdminControllerUpdate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/system/companyGroupAdmin/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemCompanyGroupAdminControllerEnable = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/system/companyGroupAdmin/{id}/enable', ...options }); };
export const systemCompanyGroupAdminControllerDisable = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/system/companyGroupAdmin/{id}/disable', ...options }); };
export const systemCompanyGroupAdminControllerUpdateCompanies = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/system/companyGroupAdmin/{id}/companies',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemCompanyControllerUpdateSettings = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/system/company/{id}/settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemCompanyControllerUpdateBranding = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/system/company/{id}/branding',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemCompanyControllerUpdateSubscriptionPlan = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/system/company/subscriptionPlan/{id}', ...options }); };
export const systemCompanyControllerEnableCompany = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/system/company/enable/{id}', ...options }); };
export const systemCompanyControllerDisableCompany = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/system/company/disable/{id}', ...options }); };
export const systemCompanyControllerSaveCompanyOwner = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/system/company/companyOwner',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemCompanyControllerUpdateCompanyOwner = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/system/company/companyOwner',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemCompanyControllerResetOwnerPassword = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/system/company/companyOwner/{ownerId}/resetPassword',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Delete a trainee
 *
 * Soft-deletes the trainee. Their data is retained internally but they can no longer log in or be queried.
 */
export const publicApiTraineeControllerDelete = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/public-api/trainees/{id}', ...options }); };
/**
 * Get a trainee by id
 *
 * Returns a single trainee in the company that owns the API key. The response has the same shape as the `trainee` object returned when creating or updating a trainee. A trainee that does not exist in your company (whether it's deleted, never existed, or belongs to another company) is a 404.
 */
export const publicApiTraineeControllerGetById = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/public-api/trainees/{id}', ...options }); };
/**
 * Update a trainee
 *
 * Update a trainee's profile fields. Pass only the fields you want to change; omitted fields are left as-is. `trainerId` reassigns the primary trainer. `secondaryTrainerIds` REPLACES the trainee's secondary trainers — omit it to leave them unchanged, or send an empty array to remove them all. Every trainer id must belong to your company, and a trainer cannot be both primary and secondary.
 */
export const publicApiTraineeControllerUpdate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/public-api/trainees/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const onboardingControllerUpdateUser = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/onboarding/update',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const onboardingControllerChangeProgram = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/onboarding/change_program',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileWorkoutControllerUpdate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/workout',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileWorkoutControllerStart = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/mobile/workout/start/{id}', ...options }); };
export const mobileWorkoutControllerReset = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/mobile/workout/reset/{id}', ...options }); };
export const mobileWorkoutControllerReplaceExercise = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/mobile/workout/replace/{programExerciseId}/{exerciseId}', ...options }); };
export const mobileWorkoutControllerFinish = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/mobile/workout/finish/{id}', ...options }); };
export const mobileWorkoutControllerAddCardioExercise = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/mobile/workout/addCardio/{workoutId}/{cardioExerciseId}', ...options }); };
export const mobileWeightTrackControllerDeleteWeightByBody = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({
        url: '/mobile/weight_track',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileWeightTrackControllerGet = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/weight_track', ...options }); };
export const mobileWeightTrackControllerUpdateWeight = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/weight_track',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileWeightTrackControllerAddWeight = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/weight_track/weight',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileWeightTrackControllerUpdateWeeklyTarget = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/weight_track/weekly/target',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileWeekControllerResetWeek = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/mobile/week/reset/{id}', ...options }); };
export const mobileWeekControllerFinishWeek = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/mobile/week/finish/{id}', ...options }); };
export const mobileBodyMeasurementV3ControllerDeleteMeasurement = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/mobile/v3/measurements/{measurementId}', ...options }); };
export const mobileBodyMeasurementV3ControllerUpdateMeasurement = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/v3/measurements/{measurementId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileBodyMeasurementV3ControllerAddBulkMeasurements = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/v3/measurements/bulk',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileBodyMeasurementControllerDeleteMeasurement = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/mobile/v2/measurements/{measurementId}', ...options }); };
export const mobileBodyMeasurementControllerUpdateMeasurement = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/v2/measurements/{measurementId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileBodyMeasurementControllerBulkUpdateMeasurements = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/v2/measurements/bulk',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileProfileControllerDeleteUser = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/mobile/trainee', ...options }); };
export const mobileProfileControllerGet = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/trainee', ...options }); };
export const mobileProfileControllerUpdate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/trainee',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileProfileControllerUploadImage = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/trainee/upload-image',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileProfileControllerUpdateProgressGymDeviceToken = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/trainee/token/new',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileProfileControllerUpdateProgressCoachDeviceToken = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/trainee/token/coach',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileProfileControllerSetPassword = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/trainee/setPassword',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileProfileControllerUpdateRepsInputRange = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/trainee/reps-input-range',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileProfileControllerChangeWeightUnit = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/mobile/trainee/changeWeight/{weightUnit}', ...options }); };
export const mobileProfileControllerChangePassword = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/trainee/changePassword',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileProfileControllerChangeLang = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/mobile/trainee/changeLang/{lang}', ...options }); };
export const mobileProgressVideoControllerSaveDateComment = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/progress-videos/date-comment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileProgressPhotoControllerSaveDateComment = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/progress-photos/date-comment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileNutritionV2ControllerMySetup = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/nutrition-v2/my-setup', ...options }); };
export const mobileNutritionV2ControllerSaveMySetup = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/nutrition-v2/my-setup',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileNutritionV2ControllerFavourites = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/nutrition-v2/favourites', ...options }); };
export const mobileNutritionV2ControllerSaveFavourites = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/nutrition-v2/favourites',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileNutritionV2ControllerChooseMenu = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/nutrition-v2/days/{date}/menu',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileNutritionV2ControllerSaveLog = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/nutrition-v2/days/{date}/log',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileTraineePersonalNotesControllerDeleteNote = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/mobile/notes/{id}', ...options }); };
export const mobileTraineePersonalNotesControllerGetNote = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/notes/{id}', ...options }); };
export const mobileTraineePersonalNotesControllerSaveNote = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/notes/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileMenuControllerRemoveSupplement = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({
        url: '/mobile/menu/supplement',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileMenuControllerAddSupplement = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/menu/supplement',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileMenuControllerUpdateMacrosPercentages = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/menu/macros_percentages',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileMenuControllerUpdateMacros = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/menu/macros',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileMenuControllerRemoveFood = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({
        url: '/mobile/menu/food',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileMenuControllerAddFood = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/menu/food',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileHomePageControllerUpdateGoal = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/home/updateGoal',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileFoodDictionaryControllerDeleteOwnFood = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/mobile/food-dictionary/{id}', ...options }); };
export const mobileFoodDictionaryControllerGetFoodById = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/food-dictionary/{id}', ...options }); };
export const mobileFoodDictionaryControllerUpdateOwnFood = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/food-dictionary/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileProgramExerciseControllerGet = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/exercise_program/{id}', ...options }); };
export const mobileProgramExerciseControllerUpdateIntervals = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/exercise_program/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileProgramExerciseControllerUpdateInterval = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/exercise_program/{id}/interval',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileProgramExerciseControllerResetCatalyst = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/mobile/exercise_program/catalyst/reset/{id}', ...options }); };
export const mobileProgramExerciseControllerResetCardio = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/mobile/exercise_program/cardio/reset/{id}', ...options }); };
export const mobileProgramExerciseControllerUpdateCardioDuration = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/exercise_program/cardio/finish',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileProgramExerciseControllerUpdateCardio = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/exercise_program/cardio/edit',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileCheckInControllerSubmitCheckIn = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/mobile/check-in/{checkInId}/submit', ...options }); };
export const mobileCheckInControllerCompleteItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/mobile/check-in/{checkInId}/item/{itemId}/complete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const groupAdminTemplateControllerGetAllNew = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/groupAdmin/template', ...options }); };
export const groupAdminTemplateControllerCreateNewTemplate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/groupAdmin/template',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const groupAdminTemplateControllerUpdateNewTemplate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/groupAdmin/template',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTranslationControllerClear = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/translation/{type}/{id}/{locale}', ...options }); };
export const adminTranslationControllerSave = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/translation/{type}/{id}/{locale}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTrainerControllerGetAll = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/trainer', ...options }); };
export const adminTrainerControllerCreate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/trainer',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTrainerControllerUpdate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/trainer',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTrainerControllerMakeUserTrainer = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/admin/trainer/{userId}', ...options }); };
export const adminTrainerControllerEnableTrainer = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/admin/trainer/enable/{id}', ...options }); };
export const adminTrainerControllerDisableTrainer = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/admin/trainer/disable/{id}', ...options }); };
export const adminTrainerControllerMakeDefaultTrainer = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/admin/trainer/default/{id}', ...options }); };
export const adminTraineeControllerGetAll = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/trainee', ...options }); };
export const adminTraineeControllerCreate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/trainee',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTraineeControllerUpdateTrainee = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/trainee',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTraineeControllerResetPassword = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/trainee/{traineeId}/resetPassword',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTraineeControllerUpdateTraineeSettings = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/trainee/{id}/settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTraineeControllerUpdateTrainer = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/admin/trainee/updateTrainer/{traineeId}/{trainerId}', ...options }); };
export const adminTraineeControllerEnableTrainees = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/trainee/enable',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTraineeControllerDisableTrainees = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/trainee/disable',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTraineeMeasurementControllerReorder = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/trainee-measurement/{traineeId}/reorder',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTraineeMeasurementControllerDeletePersonal = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/trainee-measurement/{traineeId}/personal/{definitionId}', ...options }); };
export const adminTraineeMeasurementControllerUpdatePersonal = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/trainee-measurement/{traineeId}/personal/{definitionId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTemplateControllerGetAllNew = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/template', ...options }); };
export const adminTemplateControllerCreateNewTemplate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/template',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTemplateControllerUpdateNewTemplate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/template',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTrainerTaskControllerGetTasks = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/tasks', ...options }); };
export const adminTrainerTaskControllerCreate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/tasks',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTrainerTaskControllerUpdate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/tasks',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTraineeTargetsControllerCreate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/targets',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTraineeTargetsControllerUpdate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/targets',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminSupplementControllerDeleteSupplement = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/supplement/{id}', ...options }); };
export const adminSupplementControllerGetSupplementById = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/supplement/{id}', ...options }); };
export const adminSupplementControllerUpdateSupplement = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/supplement/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminSettingControllerGet = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/setting', ...options }); };
export const adminSettingControllerUpdate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/setting',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminScheduledNotificationControllerDelete = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/scheduled-notification/{id}', ...options }); };
export const adminScheduledNotificationControllerGetById = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/scheduled-notification/{id}', ...options }); };
export const adminScheduledNotificationControllerUpdate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/scheduled-notification/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminScheduledNotificationControllerDeactivate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/admin/scheduled-notification/{id}/deactivate', ...options }); };
export const adminScheduledNotificationControllerActivate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/admin/scheduled-notification/{id}/activate', ...options }); };
export const adminScheduledCheckInControllerDelete = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/scheduled-check-in/{id}', ...options }); };
export const adminScheduledCheckInControllerGetById = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/scheduled-check-in/{id}', ...options }); };
export const adminScheduledCheckInControllerUpdate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/scheduled-check-in/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminScheduledCheckInControllerToggleActive = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/admin/scheduled-check-in/{id}/toggle-active', ...options }); };
export const adminProgressVideoControllerSaveDateComment = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/progress-videos/{traineeId}/date-comment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminProgressPhotoControllerSaveDateComment = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/progress-photos/{traineeId}/date-comment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminProgramControllerUpdateProgramWarmup = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/program/{programId}/warmup',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminProgramControllerUpdateProgramSettings = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/program/settings/{traineeId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminProgramControllerFinishWorkout = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/admin/program/finish/{workoutId}', ...options }); };
export const adminProgramControllerUpdateExerciseRange = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/program/exercise/{exerciseProgramId}/range',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminNutritionLibraryV2ControllerDeleteSavedMeal = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/nutrition-v2/saved-meals/{id}', ...options }); };
export const adminNutritionLibraryV2ControllerUpdateSavedMeal = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/nutrition-v2/saved-meals/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminNutritionMenuV2ControllerDelete = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/nutrition-v2/menus/{id}', ...options }); };
export const adminNutritionMenuV2ControllerGet = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/nutrition-v2/menus/{id}', ...options }); };
export const adminNutritionMenuV2ControllerUpdate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/nutrition-v2/menus/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminNutritionLibraryV2ControllerDeleteTemplate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/nutrition-v2/menu-templates/{id}', ...options }); };
export const adminNutritionLibraryV2ControllerGetTemplate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/nutrition-v2/menu-templates/{id}', ...options }); };
export const adminNutritionLibraryV2ControllerUpdateTemplate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/nutrition-v2/menu-templates/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTraineeNotesControllerCreate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/notes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTraineeNotesControllerUpdate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/notes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTemplateMenuControllerCreateTemplate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/menu/template',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTemplateMenuControllerSaveFullMenu = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/menu/template',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminBodyMeasurementControllerAddMeasurements = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/measurement/{traineeId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminBodyMeasurementControllerUpdateMeasurement = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/measurement/update/{measurementId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminBodyMeasurementDefinitionControllerDelete = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/measurement-definition/{id}', ...options }); };
export const adminBodyMeasurementDefinitionControllerGetById = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/measurement-definition/{id}', ...options }); };
export const adminBodyMeasurementDefinitionControllerUpdate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/measurement-definition/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminBodyMeasurementDefinitionControllerSetGenders = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/measurement-definition/{id}/genders',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminBodyMeasurementDefinitionControllerReorderGenderGrid = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/measurement-definition/grid/reorder',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminManagerControllerUpdateTrainers = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/manager/{id}/trainers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminManagerControllerUpdateCapabilities = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/manager/{id}/capabilities',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminGlobalMenuTemplateControllerCreateTemplate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/global-menu-template',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminGlobalMenuTemplateControllerSaveFullTemplate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/global-menu-template',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminFoodDictionaryControllerDeleteFood = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/food-dictionary/{id}', ...options }); };
export const adminFoodDictionaryControllerGetFood = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/food-dictionary/{id}', ...options }); };
export const adminFoodDictionaryControllerUpdateFood = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/food-dictionary/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminFoodDictionaryControllerRemoveServing = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/food-dictionary/{id}/servings/{servingId}', ...options }); };
export const adminFoodDictionaryControllerUpdateServing = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/food-dictionary/{id}/servings/{servingId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminExerciseHistoryControllerGetWeightSeriesInfo = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/exercise-history/{traineeId}/{exerciseId}/weight-series', ...options }); };
export const adminExerciseHistoryControllerUpdateWeightSet = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/exercise-history/{traineeId}/{exerciseId}/weight-series',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminExerciseHistoryControllerGetCurrentProgramExercise = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/exercise-history/{traineeId}/{exerciseId}/program-exercise', ...options }); };
export const adminExerciseHistoryControllerUpdateProgramExerciseRanges = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/exercise-history/{traineeId}/{exerciseId}/program-exercise',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminCompanyControllerUpdateSettings = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/company/settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminCompanyControllerUpdateBranding = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/company/branding',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminCheckInControllerMarkReviewed = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({ url: '/admin/check-in/{checkInId}/review', ...options }); };
export const adminAutomationFlowControllerDelete = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/automation-flows/{id}', ...options }); };
export const adminAutomationFlowControllerGet = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/automation-flows/{id}', ...options }); };
export const adminAutomationFlowControllerUpdate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/automation-flows/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminApiKeyControllerDelete = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/api-keys/{id}', ...options }); };
export const adminApiKeyControllerUpdate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).put({
        url: '/admin/api-keys/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const cIStatusWebhookControllerIngest = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/webhook/ci/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const cIStatusWebhookControllerSyncBrands = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/webhook/ci/brands',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const arboxWebhookControllerTestWebhook = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/webhook/arbox/test-webhook', ...options }); };
export const arboxWebhookControllerHandleNewClient = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/webhook/arbox/new-client',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const arboxWebhookControllerImportActiveArboxUsers = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/webhook/arbox/import', ...options }); };
export const arboxWebhookControllerImportSingleArboxUser = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/webhook/arbox/import/{arboxUserId}', ...options }); };
export const arboxWebhookControllerImportFirstActiveUser = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/webhook/arbox/import/test-one', ...options }); };
export const userControllerUpdateUser = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/user',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const testControllerImportTraineesFromCsv = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/test/import_trainees_from_csv',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemTranslationControllerRefreshLocales = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/system/translation/locales/refresh', ...options }); };
export const systemTraineeControllerImportTrainees = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/system/trainee/import',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemTemplateControllerMatchExercises = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/system/template/match-exercises',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemTemplateControllerImportTemplate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/system/template/import',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemTemplateControllerDuplicateNewTemplate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/system/template/duplicate/{id}', ...options }); };
export const systemStatisticsControllerRefreshArboxCollections = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/system/statistics/arbox-collections/refresh', ...options }); };
export const systemProgramArchiveControllerBackfill = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/system/program-archive/backfill', ...options }); };
export const systemProgramArchiveControllerBackfillSpecific = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/system/program-archive/backfill/programs', ...options }); };
export const systemProgramArchiveControllerBackfillNodeIndex = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/system/program-archive/backfill-node-index', ...options }); };
export const systemPartnershipControllerCreate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/system/partnership',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemMigrationControllerMigrateExerciseHistory = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/system/migration/exercise-history', ...options }); };
export const systemMigrationControllerQueueExerciseHistoryMigration = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/system/migration/exercise-history/queue', ...options }); };
export const systemImpersonationControllerImpersonateUser = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/system/impersonate/user/{userId}', ...options }); };
export const systemImpersonationControllerStopImpersonation = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/system/impersonate/stop', ...options }); };
export const systemFoodDictionaryControllerSearchFoods = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/food-dictionary', ...options }); };
export const systemFoodDictionaryControllerCreateFood = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/system/food-dictionary',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemFoodDictionaryControllerAddServing = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/system/food-dictionary/{id}/servings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemFoodDictionaryControllerLabelFoodGroups = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/system/food-dictionary/food-groups/label', ...options }); };
export const systemExerciseControllerSaveExerciseV2 = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/system/exercise/v2',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemExerciseControllerBulkImportSeed = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        ...formDataBodySerializer,
        url: '/system/exercise/bulk-import-seed',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};
export const systemCouponControllerCreateCoupon = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/system/coupon',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemCompanyControllerGetAll = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/company', ...options }); };
export const systemCompanyControllerSaveCompany = (options) => {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/system/company',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options === null || options === void 0 ? void 0 : options.headers
        }
    });
};
export const systemCompanyGroupAdminControllerGetAll = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/companyGroupAdmin', ...options }); };
export const systemCompanyGroupAdminControllerCreate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/system/companyGroupAdmin',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemCompanyControllerRemoveBrandingLogo = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/system/company/{id}/brandingLogo', ...options }); };
export const systemCompanyControllerUploadBrandingLogo = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/system/company/{id}/brandingLogo',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemCompanyControllerRemoveBrandingImage = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/system/company/{id}/brandingImage', ...options }); };
export const systemCompanyControllerUploadBrandingImage = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/system/company/{id}/brandingImage',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemCompanyControllerRemoveBrandingBackground = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/system/company/{id}/brandingBackground', ...options }); };
export const systemCompanyControllerUploadBrandingBackground = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/system/company/{id}/brandingBackground',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemCompanyControllerUpdateImage = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/system/company/updateImage/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const systemCiBuildControllerRelease = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/system/ci-build/release', ...options }); };
export const systemCiBuildControllerPurge = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/system/ci-build/purge', ...options }); };
export const systemCiBuildControllerClearStale = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/system/ci-build/clear-stale', ...options }); };
export const systemCiBuildControllerBuild = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/system/ci-build/build', ...options }); };
export const systemCacheControllerClearAll = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/system/cache/clear', ...options }); };
export const systemBroadcastControllerSend = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/system/admin-message/send',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const revenueCatControllerWebhook = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/revenue_cat',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Create a trainee
 *
 * Create a new trainee in the company that owns the API key. If no trainerId is supplied, the first trainer in the company is assigned. Pass `secondaryTrainerIds` to also assign additional trainers alongside the primary one; every id must belong to your company and none may be the primary trainer. The trainee is emailed a welcome message with their login details unless you pass `sendWelcomeEmail: false`. The companyId is always derived from the API key — any value passed in the body is ignored.
 */
export const publicApiTraineeControllerCreate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/public-api/trainees',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Remove a secondary trainer from a trainee
 *
 * Unassigns a secondary trainer. The trainee's primary trainer is unaffected — use the update endpoint's `trainerId` to change that. Idempotent — removing a trainer who is not currently a secondary changes nothing and still returns 200, so the call is safe to retry. Returns the updated trainee.
 */
export const publicApiTraineeControllerRemoveSecondaryTrainer = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/public-api/trainees/{id}/secondary-trainers/{trainerId}', ...options }); };
/**
 * Add a secondary trainer to a trainee
 *
 * Assigns an additional trainer to work with the trainee alongside their primary trainer. The trainer must belong to your company. Idempotent — adding a trainer who is already a secondary changes nothing and still returns 200. A trainer cannot be both primary and secondary, so passing the trainee's current primary trainer is a 400. Returns the updated trainee.
 */
export const publicApiTraineeControllerAddSecondaryTrainer = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/public-api/trainees/{id}/secondary-trainers/{trainerId}', ...options }); };
export const onboardingControllerCreatePlan = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/onboarding', ...options }); };
export const onboardingControllerValidateSmsToken = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/onboarding/validate_sms_token',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const onboardingControllerValidateEmailToken = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/onboarding/validate_email_token',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const onboardingControllerSendSmsTokenToUser = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/onboarding/send_sms_token',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const onboardingControllerSendEmailTokenToUser = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/onboarding/send_email_token',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const onboardingControllerPotentialClient = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/onboarding/potential_client',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const onboardingControllerValidatePotentialClientToken = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/onboarding/potential_client/validate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const onboardingControllerValidateGymCode = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/onboarding/gym_code',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const onboardingControllerCreateUser = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/onboarding/create_user',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileBodyMeasurementV3ControllerAddMeasurement = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/mobile/v3/measurements',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileBodyMeasurementControllerAddMeasurement = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/mobile/v2/measurements',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileProgressVideoControllerGetVideos = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/progress-videos', ...options }); };
export const mobileProgressVideoControllerAddVideo = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/mobile/progress-videos',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileProgressPhotoControllerGetPhotos = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/progress-photos', ...options }); };
export const mobileProgressPhotoControllerAddPhoto = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/mobile/progress-photos',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileProgramControllerCreateAdditionalBlock = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/mobile/program/create_block', ...options }); };
export const mobileNutritionV2ControllerSavedMeals = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/nutrition-v2/saved-meals', ...options }); };
export const mobileNutritionV2ControllerCreateSavedMeal = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/mobile/nutrition-v2/saved-meals',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileNutritionAiV2ControllerUnderstand = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/mobile/nutrition-v2/ai/understand',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileNutritionAiV2ControllerMatch = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/mobile/nutrition-v2/ai/match',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileNutritionAiV2ControllerKeepFoods = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/mobile/nutrition-v2/ai/foods',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileMenuControllerGetMenu = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/menu', ...options }); };
export const mobileMenuControllerSaveMenu = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/mobile/menu', ...options }); };
export const mobileMenuControllerAddRecipeToMenu = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/mobile/menu/recipe',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileMediaUploadControllerUploadMedia = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).sse.post({
        url: '/mobile/media/upload',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileMediaAssetControllerInitiateUpload = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/mobile/media/assets/uploads',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileMediaAssetControllerSignParts = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/mobile/media/assets/uploads/{id}/parts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileMediaAssetControllerCompleteUpload = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/mobile/media/assets/uploads/{id}/complete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileHealthControllerSyncHealthHistory = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/mobile/health/sync-health-history',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileFormControllerSaveAnswers = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/mobile/form/{id}/answers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileFoodControllerSearchFoods = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/food', ...options }); };
export const mobileFoodControllerCreateFood = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/mobile/food',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileFoodControllerScanMeal = (options) => {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/mobile/food/scan',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options === null || options === void 0 ? void 0 : options.headers
        }
    });
};
export const mobileFoodControllerRefineMealScan = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/mobile/food/scan/refine',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileFoodDictionaryControllerSearchFoods = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/food-dictionary', ...options }); };
export const mobileFoodDictionaryControllerCreateFood = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/mobile/food-dictionary',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileCouponControllerApplyCoupon = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/mobile/coupons/apply',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileCoachChatControllerStartNewConversation = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/mobile/coach/conversation/new', ...options }); };
export const mobileCoachChatControllerStreamChat = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).sse.post({
        url: '/mobile/coach/chat/stream',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mobileCheckInControllerGetOrCreateForm = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/mobile/check-in/{checkInId}/item/{itemId}/form', ...options }); };
export const groupAdminTemplateControllerDuplicateNewTemplate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/groupAdmin/template/duplicate/{id}', ...options }); };
export const libraryMediaAssetControllerSignPartsAtGroupAdminMediaAssetsUploadsIdPartsPost = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/groupAdmin/media/assets/uploads/{id}/parts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const libraryMediaAssetControllerSignPartsAtSystemMediaAssetsUploadsIdPartsPost = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/system/media/assets/uploads/{id}/parts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const libraryMediaAssetControllerCompleteUploadAtSystemMediaAssetsUploadsIdCompletePost = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/system/media/assets/uploads/{id}/complete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const libraryMediaAssetControllerCompleteUploadAtGroupAdminMediaAssetsUploadsIdCompletePost = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/groupAdmin/media/assets/uploads/{id}/complete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const libraryMediaAssetControllerInitiateUploadAtGroupAdminMediaAssetsUploadsPost = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/groupAdmin/media/assets/uploads',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const libraryMediaAssetControllerInitiateUploadAtSystemMediaAssetsUploadsPost = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/system/media/assets/uploads',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const groupAdminExerciseControllerSaveExerciseV2 = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/groupAdmin/exercise/v2',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const authControllerSendSmsTokenToUser = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/auth/send_sms_token',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const authControllerGetTraineeInfo = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/auth/mobile/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const authControllerAuthenticateUserBySms = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/auth/login_sms',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const authControllerAuthenticateUser = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/auth/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const authControllerValidateToken = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/auth/forgotpassword/validate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const authControllerResetPassword = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/auth/forgotpassword/reset',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminWorkoutAiControllerStreamWorkoutAi = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).sse.post({
        url: '/admin/workout-ai/stream',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminWeightsControllerGetTraineeWeights = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/weights/{traineeId}', ...options }); };
export const adminWeightsControllerUpdateRow = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/weights/{traineeId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTraineeControllerRemoveSecondaryTrainer = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/trainee/{traineeId}/secondary-trainer/{trainerId}', ...options }); };
export const adminTraineeControllerAddSecondaryTrainer = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/admin/trainee/{traineeId}/secondary-trainer/{trainerId}', ...options }); };
export const adminTraineeControllerUpdateImage = (options) => {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/trainee/updateImage',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options === null || options === void 0 ? void 0 : options.headers
        }
    });
};
export const adminTraineeControllerImportTrainees = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/trainee/import',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTraineeControllerBulkDeleteTrainees = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/trainee/delete/bulk',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTraineeMeasurementControllerCreatePersonal = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/trainee-measurement/{traineeId}/personal',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTraineeMeasurementControllerUnhide = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/admin/trainee-measurement/{traineeId}/definition/{definitionId}/unhide', ...options }); };
export const adminTraineeMeasurementControllerHide = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/admin/trainee-measurement/{traineeId}/definition/{definitionId}/hide', ...options }); };
export const adminTemplateControllerMatchExercises = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/template/match-exercises',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTemplateControllerImportTemplate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/template/import',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTemplateControllerDuplicateNewTemplate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/admin/template/duplicate/{id}', ...options }); };
export const adminTrainerTaskControllerBulkAction = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/tasks/bulk',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminSupplementControllerSearchSupplements = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/supplement', ...options }); };
export const adminSupplementControllerCreateSupplement = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/supplement',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminScheduledNotificationControllerCreate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/scheduled-notification',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminScheduledCheckInControllerGetScheduledCheckIns = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/scheduled-check-in', ...options }); };
export const adminScheduledCheckInControllerCreate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/scheduled-check-in',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminRecipesControllerGetRecipes = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/recipes', ...options }); };
export const adminRecipesControllerSaveRecipe = (options) => {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/recipes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options === null || options === void 0 ? void 0 : options.headers
        }
    });
};
export const adminRecipeTagsControllerGetTags = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/recipe-tags', ...options }); };
export const adminRecipeTagsControllerCreateTag = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/recipe-tags',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminRecipeCategoriesControllerGetCategories = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/recipe-categories', ...options }); };
export const adminRecipeCategoriesControllerCreateCategory = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/recipe-categories',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminProgressVideoControllerGetVideos = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/progress-videos/{traineeId}', ...options }); };
export const adminProgressVideoControllerAddVideo = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/progress-videos/{traineeId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminProgressPhotoControllerGetPhotos = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/progress-photos/{traineeId}', ...options }); };
export const adminProgressPhotoControllerAddPhoto = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/progress-photos/{traineeId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminProgramControllerRenameWorkoutDay = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/program/workout-day/rename',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminProgramControllerMoveWorkoutDay = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/program/workout-day/move',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminProgramControllerAddWorkoutDay = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/program/workout-day/add',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminProgramControllerUpdateWorkout = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/program/updateWorkout',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminProgramControllerApprovePending = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/admin/program/pending/{pendingId}', ...options }); };
export const adminProgramControllerMigrateCompleted = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/program/migrate-completed/{traineeId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminProgramControllerChangeTraineeProgram = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/program/change/{traineeId}/{templateId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminProgramControllerBulkChangeTraineeProgram = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/program/change/bulk',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminProgramControllerBulkAssignToAllFiltered = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/program/change/bulk/all',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminProgramControllerAppendWeekToBlock = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/admin/program/block/{blockId}/week', ...options }); };
export const adminNutritionControllerCreate = (options) => {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/nutrition',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options === null || options === void 0 ? void 0 : options.headers
        }
    });
};
export const adminNutritionLibraryV2ControllerListSavedMeals = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/nutrition-v2/saved-meals', ...options }); };
export const adminNutritionLibraryV2ControllerCreateSavedMeal = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/nutrition-v2/saved-meals',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminNutritionMenuV2ControllerListForTrainee = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/nutrition-v2/menus', ...options }); };
export const adminNutritionMenuV2ControllerCreate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/nutrition-v2/menus',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminNutritionMenuV2ControllerDuplicate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/admin/nutrition-v2/menus/{id}/duplicate', ...options }); };
export const adminNutritionLibraryV2ControllerListTemplates = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/nutrition-v2/menu-templates', ...options }); };
export const adminNutritionLibraryV2ControllerCreateTemplate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/nutrition-v2/menu-templates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTraineeMessageControllerSendNotification = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/message/notification',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTraineeMessageControllerSendEmail = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/message/email',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminTemplateMenuControllerDuplicateTemplate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/admin/menu/template/duplicate/{templateId}', ...options }); };
export const adminMenuAiControllerStreamMenuAi = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).sse.post({
        url: '/admin/menu-ai/stream',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const mediaUploadControllerUploadMedia = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).sse.post({
        url: '/admin/media/upload',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminMediaAssetControllerInitiateUpload = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/media/assets/uploads',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminMediaAssetControllerSignParts = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/media/assets/uploads/{id}/parts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminMediaAssetControllerCompleteUpload = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/media/assets/uploads/{id}/complete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminBodyMeasurementDefinitionControllerGetCatalog = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/measurement-definition', ...options }); };
export const adminBodyMeasurementDefinitionControllerCreate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/measurement-definition',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminBodyMeasurementDefinitionControllerRestore = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/admin/measurement-definition/{id}/restore', ...options }); };
export const adminBodyMeasurementDefinitionControllerCreateFormula = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/admin/measurement-definition/formula/{formula}', ...options }); };
export const marketplaceControllerSubmitLead = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/marketplace/partnerships/{id}/lead',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminManagerControllerList = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/manager', ...options }); };
export const adminManagerControllerCreate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/manager',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminIntegrationControllerConnectArbox = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/integrations/arbox/connect',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminGuidesControllerGetGuides = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/guides', ...options }); };
export const adminGuidesControllerSaveGuide = (options) => {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/guides',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options === null || options === void 0 ? void 0 : options.headers
        }
    });
};
export const adminGuideTagsControllerGetTags = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/guide-tags', ...options }); };
export const adminGuideTagsControllerCreateTag = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/guide-tags',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminGuideCategoriesControllerGetCategories = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/guide-categories', ...options }); };
export const adminGuideCategoriesControllerCreateCategory = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/guide-categories',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminGlobalMenuTemplateControllerApplyToTrainee = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/global-menu-template/{templateId}/apply/{traineeId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminGlobalMenuTemplateControllerDuplicateTemplate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/admin/global-menu-template/duplicate/{templateId}', ...options }); };
export const adminFormControllerGenerateAiSummary = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/admin/form/{id}/generate-ai-summary', ...options }); };
export const adminFormControllerSaveAnswers = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/form/{id}/answers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminFormTemplateControllerGetAll = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/form-template', ...options }); };
export const adminFormTemplateControllerCreate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/form-template',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminFormTemplateControllerAssignToTrainee = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/admin/form-template/{templateId}/assign/{traineeId}', ...options }); };
export const adminFoodDictionaryControllerSearchFoods = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/food-dictionary', ...options }); };
export const adminFoodDictionaryControllerCreateFood = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/food-dictionary',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminFoodDictionaryControllerAddServing = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/food-dictionary/{id}/servings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminExerciseControllerResetToOriginal = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/admin/exercise/{id}/reset', ...options }); };
export const adminExerciseControllerSaveExerciseV2 = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/exercise/v2',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminExerciseHistoryControllerImportHistory = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/exercise-history/import',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminCompanyControllerSaveCompany = (options) => {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/company',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options === null || options === void 0 ? void 0 : options.headers
        }
    });
};
export const adminCompanyControllerUpdateBrandingLogo = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/company/updateBrandingLogo/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminCompanyControllerUpdateBrandingBackground = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/company/updateBrandingBackground/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminCompanyControllerRemoveBrandingImage = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/company/brandingImage/{companyId}', ...options }); };
export const adminCompanyControllerUploadBrandingImage = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/company/brandingImage/{companyId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminCoachDashboardControllerToggleClientReview = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/admin/coach-dashboard/clients/{traineeId}/review-toggle', ...options }); };
export const adminCheckInControllerGetCheckIns = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/check-in', ...options }); };
export const adminCheckInControllerCreate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/check-in',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminChatControllerStreamChat = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).sse.post({
        url: '/admin/chat/stream',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminAutomationFlowControllerList = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/automation-flows', ...options }); };
export const adminAutomationFlowControllerCreate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/automation-flows',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminAutomationFlowControllerTestRun = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/automation-flows/{id}/test-run',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminAutomationFlowControllerEnable = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/admin/automation-flows/{id}/enable', ...options }); };
export const adminAutomationFlowControllerDisable = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/admin/automation-flows/{id}/disable', ...options }); };
export const adminApiKeyControllerList = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/api-keys', ...options }); };
export const adminApiKeyControllerCreate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({
        url: '/admin/api-keys',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminBroadcastControllerMarkRead = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/admin/admin-message/inbox/{receiptId}/read', ...options }); };
export const adminBroadcastControllerAcknowledge = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).post({ url: '/admin/admin-message/inbox/{receiptId}/acknowledge', ...options }); };
export const adminRecipesControllerDeleteRecipe = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/recipes/{id}', ...options }); };
export const adminRecipesControllerGetRecipe = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/recipes/{id}', ...options }); };
export const adminRecipesControllerUpdateRecipe = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).patch({
        url: '/admin/recipes/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminRecipeTagsControllerDeleteTag = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/recipe-tags/{id}', ...options }); };
export const adminRecipeTagsControllerUpdateTag = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).patch({
        url: '/admin/recipe-tags/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminRecipeCategoriesControllerDeleteCategory = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/recipe-categories/{id}', ...options }); };
export const adminRecipeCategoriesControllerUpdateCategory = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).patch({
        url: '/admin/recipe-categories/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminNutritionMenuV2ControllerSetActive = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).patch({ url: '/admin/nutrition-v2/menus/{id}/active', ...options }); };
export const adminGuidesControllerDeleteGuide = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/guides/{id}', ...options }); };
export const adminGuidesControllerGetGuide = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/guides/{id}', ...options }); };
export const adminGuidesControllerUpdateGuide = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).patch({
        url: '/admin/guides/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminGuideTagsControllerDeleteTag = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/guide-tags/{id}', ...options }); };
export const adminGuideTagsControllerUpdateTag = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).patch({
        url: '/admin/guide-tags/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminGuideCategoriesControllerDeleteCategory = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/guide-categories/{id}', ...options }); };
export const adminGuideCategoriesControllerUpdateCategory = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).patch({
        url: '/admin/guide-categories/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const arboxWebhookControllerDeleteAllArboxUsers = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/webhook/arbox/users', ...options }); };
export const arboxWebhookControllerFetchArboxUsers = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/webhook/arbox/users', ...options }); };
export const arboxWebhookControllerCountActiveMembershipUsers = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/webhook/arbox/users/count-active-membership', ...options }); };
export const arboxWebhookControllerFetchAllArboxUsers = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/webhook/arbox/users/all', ...options }); };
export const arboxWebhookControllerTestConnection = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/webhook/arbox/test-connection', ...options }); };
export const arboxWebhookControllerHealth = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/webhook/arbox/health', ...options }); };
export const userControllerGetCurrentUser = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/user/me', ...options }); };
export const testControllerUpload = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/test/uploadImage', ...options }); };
export const testControllerUpdate = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/test/update_programs', ...options }); };
export const testControllerTestScript = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/test/script', ...options }); };
export const testControllerRerunManipulationForCompany = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/test/rerun_manipulation_for_company', ...options }); };
export const testControllerLoad = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/test/loadExcersice', ...options }); };
export const testControllerFixDuplicates = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/test/fix_duplicates', ...options }); };
export const testControllerDetectMissingManipulation = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/test/detect_missing_manipulation', ...options }); };
export const testControllerDeleteUser = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/test/delete_user', ...options }); };
export const systemTranslationControllerGet = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/translation/{type}/{id}', ...options }); };
export const systemTranslationControllerSchema = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/translation/schema/{type}', ...options }); };
export const systemTrainerControllerGetByCompany = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/trainer', ...options }); };
export const systemTemplateControllerDeleteNewTemplate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/system/template/{id}', ...options }); };
export const systemTemplateControllerGetNewTemplate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/template/{id}', ...options }); };
export const systemTemplateControllerGetStatistics = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/template/statistics', ...options }); };
export const systemStatisticsControllerGetCompanyBreakdown = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/statistics/company-breakdown', ...options }); };
export const systemStatisticsControllerGetArboxCollections = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/statistics/arbox-collections', ...options }); };
export const systemPartnershipControllerSearch = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/partnership/search', ...options }); };
export const systemPartnershipControllerMarketplacePreview = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/partnership/marketplace-preview', ...options }); };
export const systemFoodDictionaryControllerGetUsage = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/food-dictionary/{id}/usage', ...options }); };
export const systemFoodDictionaryControllerGetNutrientDefinitions = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/food-dictionary/nutrient-definitions', ...options }); };
export const systemFoodDictionaryControllerFoodGroupLabelStatus = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/food-dictionary/food-groups/label/status', ...options }); };
export const systemFoodDictionaryControllerFoodGroupCoverage = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/food-dictionary/food-groups/coverage', ...options }); };
export const systemExerciseControllerGet = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/exercise', ...options }); };
export const systemExerciseControllerDeleteExercise = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/system/exercise/{id}', ...options }); };
export const systemExerciseControllerGetExercise = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/exercise/{id}', ...options }); };
export const systemExerciseControllerUpgradeExercises = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/exercise/upgrade', ...options }); };
export const systemExerciseControllerGetByTypes = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/exercise/type', ...options }); };
export const systemExerciseControllerCheckExerciseName = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/exercise/check-name', ...options }); };
export const systemCouponControllerSearchCoupons = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/coupon/search', ...options }); };
export const systemCompanyGroupAdminControllerGetStats = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/companyGroupAdmin/stats', ...options }); };
export const systemCompanyGroupAdminControllerCheckAvailability = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/companyGroupAdmin/check-availability', ...options }); };
export const systemCompanyControllerGetFullCompany = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/company/{id}', ...options }); };
export const systemCompanyControllerGetCompanyUsers = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/company/{id}/users', ...options }); };
export const systemCompanyControllerGetStats = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/company/stats', ...options }); };
export const systemCompanyControllerNameUniqueness = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/company/nameValidate/{name}', ...options }); };
export const systemCiBuildControllerQueueDepth = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/ci-build/queue-depth', ...options }); };
export const systemCiBuildControllerHistory = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/ci-build/history/{brand}', ...options }); };
export const systemCiBuildControllerCurrent = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/ci-build/current', ...options }); };
export const systemCiBuildControllerBrands = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/ci-build/brands', ...options }); };
export const systemAuditLogControllerSearch = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/audit-log', ...options }); };
export const systemBroadcastControllerListSent = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/admin-message/sent', ...options }); };
export const publicBrandingControllerGetByBundleId = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/public/branding/by-bundle-id/{bundleId}', ...options }); };
/**
 * List a trainee's completed workouts for a date
 *
 * Returns every workout the trainee marked COMPLETED on the given calendar day, with full set-by-set detail (weights, reps, RIR, volume). The shape of each item in `workouts` is identical to the `data.workout` block of the WORKOUT_COMPLETED webhook payload — see Webhooks → Events. When no workout was completed that day, the response is 200 with `workouts: []` and a human-readable `message`.
 */
export const publicApiTraineeControllerListWorkouts = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/public-api/trainees/{id}/workouts', ...options }); };
/**
 * Get a trainee's body weight history
 *
 * Returns the trainee's recorded body weight over the given date range — one entry per day that has a logged weight, in ascending date order. Days without a recorded weight are omitted (the list is not padded). Both `from` and `to` are inclusive. The range may not exceed 1 year (366 days); pull longer histories with successive ranged requests. When no weight was recorded in the range, the response is 200 with `entries: []` and a human-readable `message`.
 */
export const publicApiTraineeControllerWeightHistory = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/public-api/trainees/{id}/weight-history', ...options }); };
/**
 * Get a trainee's nutrition for a date
 *
 * Returns the trainee's nutrition for the given calendar day. The full object is always returned with three parts: `menu` — the coach's nutrition menu (template) that applies to the weekday, including its id, name, type (`DETAILED_PLAN` or `MACRO_GOALS`) and macro goals (calories/protein/carbs/fats); `meals` — the foods the trainee logged themselves, grouped by meal, with per-serving macros (the coach's templated plan foods are excluded); and `totals` — the daily totals across logged foods. `menu` is `null` when no active template covers the weekday; `meals` is an empty array when the trainee logged no food that day.
 */
export const publicApiTraineeControllerNutrition = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/public-api/trainees/{id}/nutrition', ...options }); };
/**
 * Get a trainee's body-measurement history
 *
 * Returns the trainee's recorded body measurements over the given date range — one entry per recorded measurement, ascending by date. Covers every predefined type (circumferences, body-fat, and `WEIGHT`) as well as the trainee's own custom types: a custom-type entry has `type: "CUSTOM"` and a populated `customTypeName`. A day on which several types were logged yields several entries. Days/types without a recorded value are omitted (the list is not padded). Both `from` and `to` are inclusive. The range may not exceed 1 year (366 days); pull longer histories with successive ranged requests. When no measurement was recorded in the range, the response is 200 with `entries: []` and a human-readable `message`.
 */
export const publicApiTraineeControllerMeasurementHistory = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/public-api/trainees/{id}/measurements', ...options }); };
/**
 * Get a trainee's average steps over the last 7 days
 *
 * Returns the trainee's mean daily step count over a trailing 7 calendar-day window (the end day and the six days before it, both ends inclusive). The window ends on today by default, or on the optional `date` parameter when supplied — pass it to inspect an earlier week. Days on which no step count was recorded are excluded from the average — they are NOT treated as zero — so `daysCounted` reports how many of the 7 days actually contributed. The figure is rounded to the nearest whole step. When no day in the window has a recorded step count, the response is 200 with `averageSteps: null` and a human-readable `message`.
 */
export const publicApiTraineeControllerAverageSteps = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/public-api/trainees/{id}/average-steps', ...options }); };
/**
 * Search trainees by name, email, or phone
 *
 * Finds trainees in the company that owns the API key. The `q` term is matched independently against the trainee's name, email, and phone number — a trainee matches when ANY of the three contains it. Matching is case-insensitive, and it is a substring match rather than a prefix: `q=israeli` matches "Israel Israeli" and `q=example.com` matches everyone at that domain. A phone number is found in whatever format you write it — `+972527333889`, `972527333889`, `0527333889` and `052-733-3889` all match the same trainee. `%` and `_` carry no special meaning; they are matched literally. Omit `q` to list every trainee in the company. Results are always scoped to your company — you cannot find a trainee in another company. Results are paginated and ordered by name; each item has the same shape as the `trainee` object returned when creating or fetching a single trainee. When nothing matches, the response is 200 with `trainees: []` and a human-readable `message`.
 */
export const publicApiTraineeControllerSearch = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/public-api/trainees/search', ...options }); };
export const onboardingControllerGetSummary = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/onboarding/summary', ...options }); };
export const onboardingControllerIsPhoneAlreadyRegistered = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/onboarding/phone/{phone}', ...options }); };
export const onboardingControllerIsEmailAlreadyRegistered = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/onboarding/email/{email}', ...options }); };
export const appInfoControllerGetAppInfo = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile', ...options }); };
export const mobileWorkoutControllerGet = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/workout/{id}', ...options }); };
export const mobileWorkoutControllerGetWorkoutStatistic = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/workout/statistic/{id}', ...options }); };
export const mobileWeightTrackControllerGetWeightHistory = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/weight_track/weight/history', ...options }); };
export const mobileWeightTrackControllerGetWeeklyHistory = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/weight_track/weekly/history', ...options }); };
export const mobileWeightTrackControllerGetLastWeekSettings = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/weight_track/last-settings', ...options }); };
export const mobileWeightTrackControllerGetHistory = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/weight_track/history', ...options }); };
export const mobileWeekControllerGet = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/week/{id}', ...options }); };
export const mobileWeekControllerGetWeekStatistic = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/week/statistic/{id}', ...options }); };
export const mobileBodyMeasurementV3ControllerGetLatest = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/v3/measurements/latest', ...options }); };
export const mobileBodyMeasurementV3ControllerGetHistory = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/v3/measurements/history', ...options }); };
export const mobileBodyMeasurementV3ControllerGetGraphHistory = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/v3/measurements/history/graph', ...options }); };
export const mobileBodyMeasurementV3ControllerGetDefinitions = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/v3/measurements/definitions', ...options }); };
export const mobileWeightTrackNewControllerGetWeeklyHistory = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/v2/weight_track/weekly/history', ...options }); };
export const mobileBodyMeasurementControllerGetLatestMeasurements = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/v2/measurements/latest', ...options }); };
export const mobileBodyMeasurementControllerGetMeasurementHistory = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/v2/measurements/history', ...options }); };
export const mobileBodyMeasurementControllerGetMeasurementGraphHistory = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/v2/measurements/history/graph', ...options }); };
export const mobileSupplementControllerSearchSupplements = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/supplement', ...options }); };
export const mobileRecipesControllerGetRecipes = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/recipes', ...options }); };
export const mobileRecipesControllerGetTags = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/recipes/tags', ...options }); };
export const mobileRecipesControllerGetCategories = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/recipes/categories', ...options }); };
export const mobileProgramControllerGet = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/program', ...options }); };
export const mobileProgramControllerGetProgramStatistic = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/program/statistic/{id}', ...options }); };
export const mobileProgramControllerGetOpening = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/program/opening', ...options }); };
export const mobilePricingControllerGetPrices = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/pricing', ...options }); };
export const mobileNutritionV2ControllerSelfMenu = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/nutrition-v2/self-menu', ...options }); };
export const mobileNutritionV2ControllerRecentFoods = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/nutrition-v2/recent-foods', ...options }); };
export const mobileNutritionV2ControllerMenus = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/nutrition-v2/menus', ...options }); };
export const mobileNutritionV2ControllerAlternatives = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/nutrition-v2/foods/{foodId}/alternatives', ...options }); };
export const mobileNutritionV2ControllerFavouriteFoods = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/nutrition-v2/favourites/foods', ...options }); };
export const mobileNutritionV2ControllerDays = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/nutrition-v2/days', ...options }); };
export const mobileNutritionV2ControllerDay = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/nutrition-v2/days/{date}', ...options }); };
export const mobileMenuControllerGetAlternatives = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/menu/alternatives', ...options }); };
export const mobileMediaAssetControllerGetAsset = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/media/assets/{id}', ...options }); };
export const mobileHomePageControllerGetHomePageStats = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/home', ...options }); };
export const mobileHealthControllerDeleteAllHealthData = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/mobile/health', ...options }); };
export const mobileHealthControllerGetAllHealthData = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/health', ...options }); };
export const mobileHealthControllerGetLastSyncDate = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/health/last-sync-date', ...options }); };
export const mobileHealthControllerGetHistory = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/health/history', ...options }); };
export const mobileHealthControllerGetHealthGoals = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/health/goals', ...options }); };
export const mobileGuidesControllerGetGuides = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/guides', ...options }); };
export const mobileGuidesControllerGetTags = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/guides/tags', ...options }); };
export const mobileGuidesControllerGetCategories = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/guides/categories', ...options }); };
export const mobileFormControllerGetMyForms = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/form', ...options }); };
export const mobileFormControllerGetForm = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/form/{id}', ...options }); };
export const mobileFoodControllerGetAvailableServingSizes = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/food/{foodId}/serving-sizes', ...options }); };
export const mobileFoodControllerGetFoodHistory = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/food/history', ...options }); };
export const mobileFoodControllerGetFoodHistoryV2 = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/food/history/v2', ...options }); };
export const mobileFoodDictionaryControllerGetServings = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/food-dictionary/{id}/servings', ...options }); };
export const mobileFoodDictionaryControllerGetNutrientDefinitions = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/food-dictionary/nutrient-definitions', ...options }); };
export const mobileExerciseControllerGetExercise = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/exercise/{id}', ...options }); };
export const mobileExerciseControllerGetSimilarExercises = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/exercise/similar/{id}', ...options }); };
export const mobileExerciseControllerSearchExercises = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/exercise/search', ...options }); };
export const mobileExerciseControllerGetCardioExercises = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/exercise/cardio', ...options }); };
export const mobileExerciseHistoryControllerGetSessionHistory = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/exercise-history/{exerciseId}/sessions', ...options }); };
export const mobileExerciseHistoryControllerGetMetadata = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/exercise-history/{exerciseId}/metadata', ...options }); };
export const mobileCouponControllerValidateCoupon = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/coupons/validate', ...options }); };
export const mobileCoachChatControllerGetConversation = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/coach/conversation/{conversationId}', ...options }); };
export const mobileCheckInControllerGetMyCheckIns = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/check-in', ...options }); };
export const mobileCheckInControllerGetCheckIn = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/mobile/check-in/{checkInId}', ...options }); };
export const groupAdminTemplateControllerDeleteNewTemplate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/groupAdmin/template/{id}', ...options }); };
export const groupAdminTemplateControllerGetNewTemplate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/groupAdmin/template/{id}', ...options }); };
export const groupAdminTemplateControllerGetStatistics = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/groupAdmin/template/statistics', ...options }); };
export const libraryMediaAssetControllerGetAssetAtGroupAdminMediaAssetsIdGet = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/groupAdmin/media/assets/{id}', ...options }); };
export const libraryMediaAssetControllerGetAssetAtSystemMediaAssetsIdGet = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/media/assets/{id}', ...options }); };
export const groupAdminExerciseControllerGet = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/groupAdmin/exercise', ...options }); };
export const groupAdminExerciseControllerDeleteExercise = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/groupAdmin/exercise/{id}', ...options }); };
export const groupAdminExerciseControllerGetExercise = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/groupAdmin/exercise/{id}', ...options }); };
export const groupAdminExerciseControllerLibrary = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/groupAdmin/exercise/library', ...options }); };
export const groupAdminExerciseControllerLibraryExercise = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/groupAdmin/exercise/library/{id}', ...options }); };
export const groupAdminExerciseControllerCheckExerciseName = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/groupAdmin/exercise/check-name', ...options }); };
export const clientConfigControllerGetConfigAtSystemConfigGet = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/system/config', ...options }); };
export const clientConfigControllerGetConfigAtAdminConfigGet = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/config', ...options }); };
export const clientConfigControllerGetConfigAtGroupAdminConfigGet = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/groupAdmin/config', ...options }); };
export const authControllerAuthenticateDemoUser = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/auth/login_demo_user', ...options }); };
export const authControllerGenerateForgottenPasswordToken = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/auth/forgotpassword/{email}', ...options }); };
export const adminWeightsControllerGetWeightTable = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/weights/table/{traineeId}', ...options }); };
export const adminUserControllerSearch = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/user', ...options }); };
export const adminTranslationControllerGet = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/translation/{type}/{id}', ...options }); };
export const adminTranslationControllerSchema = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/translation/schema/{type}', ...options }); };
export const adminTrainerControllerDelete = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/trainer/{id}', ...options }); };
export const adminTrainerControllerGet = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/trainer/{id}', ...options }); };
export const adminTraineeControllerDeleteUser = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/trainee/{id}', ...options }); };
export const adminTraineeControllerGet = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/trainee/{id}', ...options }); };
export const adminTraineeControllerGetNutritionCalculatorData = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/trainee/{id}/nutrition-calculator-data', ...options }); };
export const adminTraineeControllerUserIdByEmail = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/trainee/user-id-by-email', ...options }); };
export const adminTraineeControllerGetTraineeStatistics = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/trainee/statistics', ...options }); };
export const adminTraineeControllerGetEnhancedStatistics = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/trainee/statistics/enhanced', ...options }); };
export const adminTraineeControllerCheckEmailExists = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/trainee/check-email', ...options }); };
export const adminTraineeMeasurementControllerGetGrid = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/trainee-measurement/{traineeId}/grid', ...options }); };
export const adminTemplateControllerDeleteNewTemplate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/template/{id}', ...options }); };
export const adminTemplateControllerGetNewTemplate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/template/{id}', ...options }); };
export const adminTemplateControllerGetStatistics = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/template/statistics', ...options }); };
export const adminTrainerTaskControllerGetSuggestions = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/tasks/suggestions', ...options }); };
export const adminTrainerTaskControllerGetPendingCount = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/tasks/count', ...options }); };
export const adminTraineeTargetsControllerGetAll = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/targets/{traineeId}', ...options }); };
export const adminStatisticsControllerGet = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/statistics', ...options }); };
export const adminStatisticsControllerGetEnhancedStats = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/statistics/enhanced', ...options }); };
export const adminScheduledNotificationControllerSearch = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/scheduled-notification/search', ...options }); };
export const adminProgramControllerGetActiveProgram = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/program/{traineeId}', ...options }); };
export const adminProgramControllerGetProgramById = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/program/{traineeId}/{programId}', ...options }); };
export const adminProgramControllerGetWorkout = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/program/workout/{workoutId}', ...options }); };
export const adminProgramControllerGetWeeklySummary = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/program/weekly-summary', ...options }); };
export const adminProgramControllerGetWeek = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/program/week/{weekId}', ...options }); };
export const adminProgramControllerGetWeekStatistics = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/program/week/{weekId}/statistics', ...options }); };
export const adminProgramControllerGetPendingPrograms = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/program/pending', ...options }); };
export const adminProgramControllerRunManipulation = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/program/manipulation/{traineeId}/{programId}/{weekId}', ...options }); };
export const adminProgramControllerGetHistory = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/program/history/{traineeId}', ...options }); };
export const adminProgramControllerCreateAdditionalBlock = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/program/create_block/{programId}', ...options }); };
export const adminProgramControllerGetBulkAssignCount = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/program/change/bulk/count', ...options }); };
export const adminNutritionControllerGet = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/nutrition/{trainerId}', ...options }); };
export const adminNutritionControllerGetLatest = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/nutrition/latest/{trainerId}', ...options }); };
export const adminNutritionDayLogV2ControllerDay = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/nutrition-v2/trainees/{traineeId}/days/{date}', ...options }); };
export const adminTraineeNotesControllerGetAll = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/notes/{traineeId}', ...options }); };
export const adminTemplateMenuControllerDeleteTemplate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/menu/template/{templateId}', ...options }); };
export const adminTemplateMenuControllerGetTemplateById = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/menu/template/{templateId}', ...options }); };
export const adminTemplateMenuControllerGetAllTemplatesForTrainee = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/menu/template/trainee/{traineeId}', ...options }); };
export const adminTemplateMenuControllerGetOccupiedDays = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/menu/template/occupied-days/{traineeId}', ...options }); };
export const adminMediaAssetControllerGetAsset = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/media/assets/{id}', ...options }); };
export const adminBodyMeasurementControllerGetLast7ByDefinition = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/measurement/{traineeId}/def/{definitionId}', ...options }); };
export const adminBodyMeasurementControllerGetAllByDefinition = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/measurement/{traineeId}/def/{definitionId}/all', ...options }); };
export const adminBodyMeasurementControllerGetMeasurementMatrix = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/measurement/matrix/{traineeId}', ...options }); };
export const adminBodyMeasurementControllerGetLatestMeasurements = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/measurement/latest/{traineeId}', ...options }); };
export const adminBodyMeasurementControllerGetDefinitionsForTrainee = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/measurement/definitions/{traineeId}', ...options }); };
export const adminBodyMeasurementDefinitionControllerGetDeleteImpact = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/measurement-definition/{id}/impact', ...options }); };
export const adminBodyMeasurementDefinitionControllerGetFormulaPreview = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/measurement-definition/{id}/formula-preview', ...options }); };
export const adminBodyMeasurementDefinitionControllerGetHidden = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/measurement-definition/hidden', ...options }); };
export const adminBodyMeasurementDefinitionControllerGetGenderGrid = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/measurement-definition/grid', ...options }); };
export const marketplaceControllerStatus = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/marketplace/status', ...options }); };
export const marketplaceControllerList = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/marketplace/partnerships', ...options }); };
export const marketplaceControllerGetById = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/marketplace/partnerships/{id}', ...options }); };
export const adminManagerControllerRevoke = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/manager/{id}', ...options }); };
export const adminManagerControllerGet = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/manager/{id}', ...options }); };
export const adminManagerControllerCheckAvailability = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/manager/check-availability', ...options }); };
export const adminManagerControllerCapabilities = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/manager/capabilities', ...options }); };
export const adminIntegrationControllerArboxFields = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/integrations/arbox/fields', ...options }); };
export const adminGlobalMenuTemplateControllerDeleteTemplate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/global-menu-template/{templateId}', ...options }); };
export const adminGlobalMenuTemplateControllerGetTemplateById = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/global-menu-template/{templateId}', ...options }); };
export const adminGlobalMenuTemplateControllerGetTemplatesForCurrentUserCompany = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/global-menu-template/company', ...options }); };
export const adminFormControllerDelete = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/form/{id}', ...options }); };
export const adminFormControllerGetById = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/form/{id}', ...options }); };
export const adminFormControllerGetByTrainee = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/form/trainee/{traineeId}', ...options }); };
export const adminFormTemplateControllerGetTraineesWithFormStatus = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/form-template/{templateId}/trainees', ...options }); };
export const adminFormTemplateControllerGetFormsByTemplate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/form-template/{templateId}/forms', ...options }); };
export const adminFormTemplateControllerGetFormsCountByTemplate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/form-template/{templateId}/forms/count', ...options }); };
export const adminFormTemplateControllerCanAssignToTrainee = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/form-template/{templateId}/canAssign/{traineeId}', ...options }); };
export const adminFormTemplateControllerDelete = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/form-template/{id}', ...options }); };
export const adminFormTemplateControllerGetById = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/form-template/{id}', ...options }); };
export const adminTraineeFoodLogGetTraineeFoodLog = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/food-log/trainee/{traineeId}/{weekDate}', ...options }); };
export const adminTraineeFoodLogGetTraineeFoodLogSummary = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/food-log/summary/trainee/{traineeId}', ...options }); };
export const adminFoodDictionaryControllerGetUsage = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/food-dictionary/{id}/usage', ...options }); };
export const adminFoodDictionaryControllerGetNutrientDefinitions = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/food-dictionary/nutrient-definitions', ...options }); };
export const adminExerciseControllerGet = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/exercise', ...options }); };
export const adminExerciseControllerDeleteExercise = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/exercise/{id}', ...options }); };
export const adminExerciseControllerGetExercise = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/exercise/{id}', ...options }); };
export const adminExerciseControllerGetByTypes = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/exercise/type', ...options }); };
export const adminExerciseControllerCheckExerciseName = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/exercise/check-name', ...options }); };
export const adminExerciseHistoryControllerGetSessionHistory = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/exercise-history/{traineeId}/{exerciseId}/sessions', ...options }); };
export const adminExerciseHistoryControllerGetMetadata = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/exercise-history/{traineeId}/{exerciseId}/metadata', ...options }); };
export const adminCompanyControllerGetCompany = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/company/company/{id}', ...options }); };
export const adminCoachDashboardControllerGetWeightWeeklySummary = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/coach-dashboard/weight/weekly-summary', ...options }); };
export const adminCoachDashboardControllerGetTraineeProfile = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/coach-dashboard/trainee/{traineeId}', ...options }); };
export const adminCoachDashboardControllerGetStepsWeeklySummary = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/coach-dashboard/steps/weekly-summary', ...options }); };
export const adminCoachDashboardControllerGetNutritionWeeklySummary = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/coach-dashboard/nutrition/weekly-summary', ...options }); };
export const adminCoachDashboardControllerGetClientsWeeklySummary = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/coach-dashboard/clients/weekly-summary', ...options }); };
export const adminCoachDashboardControllerGetCheckInsWeeklySummary = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/coach-dashboard/check-ins/weekly-summary', ...options }); };
export const adminClientReviewControllerGetLiveClientOverview = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/client-reviews/live', ...options }); };
export const adminCheckInControllerDelete = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/check-in/{checkInId}', ...options }); };
export const adminCheckInControllerGetById = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/check-in/{checkInId}', ...options }); };
export const adminCheckInControllerGetTraineeCheckIns = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/check-in/trainee/{traineeId}', ...options }); };
export const adminCheckInControllerGetStats = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/check-in/stats', ...options }); };
export const adminCheckInControllerGetPendingCount = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/check-in/pending-count', ...options }); };
export const adminAutomationFlowControllerListExecutions = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/automation-flows/{id}/executions', ...options }); };
export const adminAutomationFlowControllerGetExecution = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/automation-flows/executions/{executionId}', ...options }); };
export const adminAutomationFlowControllerBricks = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/automation-flows/bricks', ...options }); };
export const adminApiKeyControllerGetDocsUrl = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/api-keys/docs-url', ...options }); };
export const adminAlertControllerGetAll = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/alert', ...options }); };
export const adminBroadcastControllerListInbox = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/admin-message/inbox', ...options }); };
export const adminBroadcastControllerUnreadCount = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/admin-message/inbox/unread-count', ...options }); };
export const adminBroadcastControllerNextUnacknowledged = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).get({ url: '/admin/admin-message/inbox/next-unacknowledged', ...options }); };
export const systemCompanyControllerRemoveWeekImage = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/system/company/{id}/weekImage/{imageKey}', ...options }); };
export const systemCompanyControllerDeleteCompany = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/system/company/{companyId}', ...options }); };
export const systemCompanyControllerDeleteCompanyOwner = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/system/company/companyOwner/{ownerId}', ...options }); };
export const systemBroadcastControllerDeleteSent = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/system/admin-message/sent/{id}', ...options }); };
export const mobileWorkoutControllerRemoveCardioExercise = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/mobile/workout/removeCardio/{workoutId}', ...options }); };
export const mobileWeightTrackControllerDeleteWeightByDate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/mobile/weight_track/{date}', ...options }); };
export const mobileProfileControllerDeleteImage = (options) => { var _a; return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/mobile/trainee/image', ...options }); };
export const mobileProgressVideoControllerDeleteVideo = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/mobile/progress-videos/{videoId}', ...options }); };
export const mobileProgressVideoControllerDeleteVideosByDate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/mobile/progress-videos/date/{videoDate}', ...options }); };
export const mobileProgressPhotoControllerDeletePhoto = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/mobile/progress-photos/{photoId}', ...options }); };
export const mobileProgressPhotoControllerDeletePhotosByDate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/mobile/progress-photos/date/{photoDate}', ...options }); };
export const mobileNutritionV2ControllerDeleteSavedMeal = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/mobile/nutrition-v2/saved-meals/{id}', ...options }); };
export const mobileMediaAssetControllerAbortUpload = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/mobile/media/assets/uploads/{id}', ...options }); };
export const libraryMediaAssetControllerAbortUploadAtGroupAdminMediaAssetsUploadsIdDelete = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/groupAdmin/media/assets/uploads/{id}', ...options }); };
export const libraryMediaAssetControllerAbortUploadAtSystemMediaAssetsUploadsIdDelete = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/system/media/assets/uploads/{id}', ...options }); };
export const adminTrainerTaskControllerDelete = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/tasks/{id}', ...options }); };
export const adminTraineeTargetsControllerDelete = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/targets/{id}', ...options }); };
export const adminProgressVideoControllerDeleteVideo = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/progress-videos/{traineeId}/{videoId}', ...options }); };
export const adminProgressVideoControllerDeleteVideosByDate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/progress-videos/{traineeId}/date/{videoDate}', ...options }); };
export const adminProgressPhotoControllerDeletePhoto = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/progress-photos/{traineeId}/{photoId}', ...options }); };
export const adminProgressPhotoControllerDeletePhotosByDate = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/progress-photos/{traineeId}/date/{photoDate}', ...options }); };
export const adminProgramControllerRemoveWorkoutDay = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({
        url: '/admin/program/workout-day/remove',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminProgramControllerResetWeek = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/program/reset/{weekId}', ...options }); };
export const adminProgramControllerDeleteBlock = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/program/block/{blockId}', ...options }); };
export const adminNutritionControllerDelete = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/nutrition/{nutritionId}', ...options }); };
export const adminTraineeNotesControllerDelete = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/notes/{id}', ...options }); };
export const adminMediaAssetControllerAbortUpload = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/media/assets/uploads/{id}', ...options }); };
export const adminBodyMeasurementControllerDeleteMeasurement = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/measurement/{measurementId}', ...options }); };
export const adminBodyMeasurementDefinitionControllerRemoveFromGender = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/measurement-definition/{id}/genders/{gender}', ...options }); };
export const adminCompanyControllerRemoveWeekImage = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/company/weekImage/{companyId}/{imageKey}', ...options }); };
export const adminCompanyControllerRemoveBrandingLogo = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/company/removeBrandingLogo/{id}', ...options }); };
export const adminCompanyControllerRemoveBrandingBackground = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/company/removeBrandingBackground/{id}', ...options }); };
export const adminAlertControllerDeleteAlert = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/alert/{id}', ...options }); };
export const adminBroadcastControllerDeleteReceipt = (options) => { var _a; return ((_a = options.client) !== null && _a !== void 0 ? _a : client).delete({ url: '/admin/admin-message/inbox/{receiptId}', ...options }); };
